import { useEffect, useState } from 'react';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { useAuth } from 'context/AuthContext';
import { getManifest, IManifest } from 'services/manifest.service';

import './styles.scss';

export function Manifesto() {
  const [manifest, setManifest] = useState<IManifest>();
  const [load, setLoad] = useState<boolean>(true);
  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      const data = await getManifest(user?.extra.rede);
      if (data) setManifest(data);
      setLoad(false);
    }

    loadData();
  }, [user?.extra.rede]);

  return (
    <RebrandShell title="Nosso Manifesto" subtitle="O que move o Reconheça BRB.">
      <div className="rb-panel">
        {load && <div className="rb-skeleton" style={{ height: 200 }} />}
        {!load && manifest?.text && (
          <div className="rb-prose rb-manifesto" dangerouslySetInnerHTML={{ __html: manifest.text }} />
        )}
      </div>
    </RebrandShell>
  );
}
